import React, { useEffect } from "react";
import { EntityId } from "@reduxjs/toolkit";
import { useAppSelector } from "../../../../store/hooks";
import { WorldInterface } from "../../../../store/mine_craft/worldsSlice";
import { filterOption } from "../../../../helpers/FormHelper";
import { selectCategoryEntities, selectCategoryIds } from "../../../../store/mine_craft/categoriesSlice";

import { Button, Form, Input, Radio, Select } from "antd";
import FileDropzone from "../../../../componets/FileDropzone";

interface propsInterface {
  params?: WorldInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const categories = useAppSelector(selectCategoryEntities);
  const categoryIds = useAppSelector(selectCategoryIds);

  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const renderCategoryOption = (id: EntityId) => {
    const item = categories[id];

    if (!item) {
      return null;
    }

    return <Select.Option key={id} value={id} title={item.title}>{item.title}</Select.Option>
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='thumbnail' label='Thumbnail' preview={params?.thumbnail_url} />
        <FileDropzone name='mcworld' label='McWorld' preview={params?.mcworld_url} />
      </div>

      <Form.Item name='title' label="Title">
        <Input placeholder='Title' />
      </Form.Item>

      <Form.Item
        name='category_ids'
        label="Select a category"
      >
        <Select
          mode="multiple"
          allowClear
          showSearch
          filterOption={filterOption}
          placeholder='Select a category'
        >
          {categories && categoryIds.map(renderCategoryOption)}
        </Select>
      </Form.Item>

      <Form.Item label="Pro" name='pro'>
        <Radio.Group>
          <Radio value={1}>Free</Radio>
          <Radio value={2}>Premium</Radio>
          <Radio value={3}>Ads</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item name='body' label="Body">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item name='search_text' label="Search Text">
        <Input.TextArea rows={3} />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
